angular.module('impactx.input').directive('ixCompanyAvatarSelect', function () {
    return {
        scope: {
            selected: '=',
            label: '@',
            onSelect: '&',
            entrypoint: '@'
        },
        controller: 'CompanyAvatarSelectCtrl',
        controllerAs: 'companyAvatarSelectCtrl',
        restrict: 'E',
        templateUrl: 'shared/input/templates/companyavatarselect.tmpl.html',
        link: function(scope, element) {
            // target for the panel is the wrapping div
            // this way the panel does not "jump around" when clicking on different parts of the select
            scope.target = element[0].querySelector("div.company-avatar-select");
        }
    };
});